<section class="relative">
  <div class="absolute post-16 posr-16">
    <a mat-stroked-button paint="primary" routerLink="/faqs-mt">
        <span>Switch to </span>
        <mat-icon svgIcon="logo:malta" iconPositionEnd></mat-icon>
    </a>
  </div>
  <h1 class="mat-display-1">Frequently Asked Questions</h1>
</section>
<div class="content">
  <mat-accordion>
    <!-- !GENERAL QUESTIONS -->
    <div>
      <h2 paint="primary" extrabold>General Questions</h2>
      <mat-expansion-panel [expanded]="!fragment() || fragment() == 'cloudigo'">
        <mat-expansion-panel-header>
          <h3 id="cloudigo">What is cloudigo?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            cloudigo is a digital experience that brings you closer to your favourite brands and allows you to save
            money on your favourite fashion brands, food destinations and more. cloudigo is available via a free mobile application on <a [href]="ios" target="_blank">iOS</a> and <a
              [href]="android" target="_blank">Android</a> or on <a
              routerLink="/">www.cloudigo.app</a>.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('get')" [expanded]="fragment() == 'get'">
        <mat-expansion-panel-header>
          <h3 id="get">What do I get with cloudigo?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            When downloading the app and creating an account, you will get access to <span class="font-bold">discounts</span> from hundreds of brands. 
            <br /><br />
            Once you do so, you will see blue discounts and red discounts.
            <br /><br />
          </p>
            <ul>
              <li>
                The <span paint="primary">blue</span> discounts can be used for FREE, whilst
              </li>
              <li>
                The <span paint="warn">red</span> discounts can be used by Premium users only
              </li>
            </ul>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('download')" [expanded]="fragment() == 'download'">
        <mat-expansion-panel-header>
          <h3 id="download">How do I download and sign up to cloudigo?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            All you need to do is sign up on our <a routerLink="/signup">website</a>, or <a routerLink="/get-the-app">download the free app</a>. You can also visit the App Store or Google Play Store on your smartphone to download the app.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('premium')" [expanded]="fragment() == 'premium'">
        <mat-expansion-panel-header>
          <h3 id="premium">What is cloudigo Premium</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            cloudigo Premium is a yearly membership which allows you to use the red discoutns on the app. These <span paint="warn">red</span> discounts include:
          </p>
           <ul>
              <li>Unlimited discounts</li>
              <li>2 for 1 on main courses</li>
              <li>Discounts up to 50% and much more</li>
            </ul>
            <br/>
          <p>
            You can click <a [routerLink]="['/premium']">here</a> to learn more
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('2for1')" [expanded]="fragment() == '2for1'">
        <mat-expansion-panel-header>
          <h3 id="2for1">Do you have 2 for 1 offers on cloudigo?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Yes we do! You can see a full list of the 2 for 1 Offers on cloudigo by opening the application and scrolling down to the 2 for 1 Offers section. These can be used by Premium subscribers only.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('contact')" [expanded]="fragment() == 'contact'">
        <mat-expansion-panel-header>
          <h3 id="contact">How do I contact cloudigo?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            You can contact us via email, facebook messenger or our contact form:
          </p>
            <ul>
              <li>
                Contact form: <a routerLink="/contact-us">cloudigo.app/contact-us</a>
              </li>
              <li>
                Email: <a href="mailto:support@cloudigo.app">support&#64;cloudigo.app</a>
              </li>
              <li>
                Facebook: <a target="_top" rel="noreferrer" href="https://facebook.com/cloudigo">facebook.com/cloudigo</a>
              </li>
            </ul>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('location')" [expanded]="fragment() == 'location'">
        <mat-expansion-panel-header>
          <h3 id="location">Where are the cloudigo offices?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Our offices are located at cloudigo Ltd, 90, Office 1, Level 1, Psaila Street, Birkirkara. We are in between Europharma and Andrew’s Bar, on top of a car showroom called Caro Motors.
            <br/><br/>

            Opening hours:
          </p>
            <ul>
              <li>
                Monday to Friday
              </li>
              <li>
                9am - 5pm
              </li>
            </ul>

        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('comm_preferences')" [expanded]="fragment() == 'comm_preferences'">
        <mat-expansion-panel-header>
          <h3 id="comm_preferences">How do I manage my communication preferences?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            To manage your communication preferences, simply <a routerLink="/login">login</a> to your cloudigo account and visit your <a routerLink="/profile">account profile</a>. In your account profile, you have the ability to switch on and off the <a routerLink="/profile/preferences">communication settings</a> related to cloudigo.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('forget_password')" [expanded]="fragment() == 'forget_password'">
        <mat-expansion-panel-header>
          <h3 id="forget_password">What do I do if I forget my password?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            It's easy! Simply click <a routerLink="/recovery/forgot">here</a> and enter your email address.
            <br/><br/>
            If you haven't received a recovery email, kindly send us an email to <a href="mailto:support@cloudigo.app">support&#64;cloudigo.app</a>
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('change_email')" [expanded]="fragment() == 'change_email'">
        <mat-expansion-panel-header>
          <h3 id="change_email">I want to change the email address?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            If you want to change the email address associated with your cloudigo account, kindly send us an email to <a href="mailto:support@cloudigo.app">support&#64;cloudigo.app</a>
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('blue_offers')" [expanded]="fragment() == 'blue_offers'">
        <mat-expansion-panel-header>
          <h3 id="blue_offers">What do the offers marked in blue mean?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            The offer cards marked in <span paint="primary">blue</span> refer to discounts that may be used for free. They are usually a one-time 10% discount.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('locked_offers')" [expanded]="fragment() == 'locked_offers'">
        <mat-expansion-panel-header>
          <h3 id="locked_offers">Why are there locked offers on cloudigo?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            The offers that are locked are usually <span paint="warn">red</span> offers. These offers may only be used if you have a Premium membership.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('red_offers')" [expanded]="fragment() == 'red_offers'">
        <mat-expansion-panel-header>
          <h3 id="red_offers">What do the offers marked in red mean?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            The offer cards marked in <span paint="warn">red</span> refer to Premium discounts that may be used by the cloudigo Premium users only. These include:
          </p>
            <ul>
              <li>
                Unlimited discounts
              </li>
              <li>
                2 for 1 on main courses
              </li>
              <li>
                Discounts up to 50% and much more
              </li>
            </ul>
          <p>
            To become a Premium member, click <a [routerLink]="['/premium']">here</a> to view our plans
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('grey_offers')" [expanded]="fragment() == 'grey_offers'">
        <mat-expansion-panel-header>
          <h3 id="grey_offers">Why do the offers marked in grey mean?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            If the offer card on the app is grey and the button shows ‘<span class="font-bold">NOT VALID TODAY</span>’, or if on the offer page at the bottom there is a grey button showing ‘<span class="font-bold">NOT VALID TODAY</span>’, this means that the offer is not valid and cannot be redeemed on that particular day. If the offer card shows a specific time in which the offer is valid, this means that the offer cannot be redeemed outside of these hours.
            <br/><br/>
            If the offer card used on the app is grey and the button shows ‘<span class="font-bold">USED</span>’, or if on the offer page at the bottom there is a grey button showing ‘<span class="font-bold">USED</span>’, this means that the number of limited redemptions have been used up and the offer cannot be used again until the period of time required for the offer to be reset has passed.

          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('gift')" [expanded]="fragment() == 'gift'">
        <mat-expansion-panel-header>
          <h3 id="gift">I won a gift from a quiz on the cloudigo app. What should I do?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            If you won a gift from a quiz on cloudigo, kindly:
          </p>
          <ol>
              <li>
                Open the <span class="font-bold">cloudigo application</span>
              </li>
              <li>
                Click on the <span class="font-bold">Wallet</span> icon on the top right
              </li>
              <li>
                Click on <span class="font-bold">Vouchers</span>
              </li>
              <li>
                Check <span class="font-bold">where</span> it is redeemable and visit the respective shop or restaurant
              </li>
              <li>
                Press on <span class="font-bold">Get Code</span>
              </li>
              <li>
                Scan the <span class="font-bold">QR Code</span> provided by the shop or restaurant
              </li>
            </ol>
            <br/><br/>
          <p>
            If it is redeemable at the ‘cloudigo offices’, please visit the cloudigo offices at the following address from Monday to Friday between 9am and 4pm;
            <br/><br/>
            cloudigo Ltd, 90, Office 1, Level 1, Psaila Street, Birkirkara.  
            <br/>
            We are in between Europharma and Andrew’s Bar, on top of a car showroom called Caro Motors.

          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('delete')" [expanded]="fragment() == 'delete'">
        <mat-expansion-panel-header>
          <h3 id="delete">I want to delete my cloudigo account. What should I do?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>Deletion of account may be <span class="font-bold">unnecessary especially when reusing the same email address</span> for another account.</p>
          <p>Otherwise:</p>
          <ol>
            <li>
              Open the <span class="font-bold">cloudigo application</span>
            </li>
            <li>
              Click on the <span class="font-bold">Profile</span> icon on the top right
            </li>
            <li>
              Click on <span class="font-bold">"My details"</span>
            </li>
            <li>Press on <span class="font-bold">"Delete Account"</span> button at the bottom 
            <li>Lastly, you will be asked for <span class="font-bold">confirmation of deletion</span>.</li>
          </ol>
          <br/>
          <p><span class="font-bold">N.B.</span> There is a quarantine of 24 hours to create an account with the same email address</p>
          <p>
            For support, kindly send us an email to <a href="mailto:support@cloudigo.app">support&#64;cloudigo.app</a>
          </p>
        </ng-template>
      </mat-expansion-panel>

    </div>
    <!-- !PREMIUM SECTION -->
    <div>
      <h2 paint="warn" extrabold>Question about cloudigo Premium</h2>
      <mat-expansion-panel class="premium" (afterExpand)="onExpand('cloudigo-premium')" [expanded]="fragment() == 'cloudigo-premium'">
        <mat-expansion-panel-header>
          <h3 id="cloudigo-premium">Why should I buy a cloudigo Premium membership? </h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            The cloudigo Premium Plan gives you exclusive access to:
          </p>
            <ul>
              <li>
                Unlimited discounts
              </li>
              <li>
                2 for 1 on main courses
              </li>
              <li>
                Discounts up to 50% and much more
              </li>
            </ul>
            <br /><br />
          <p>
            Click <a [routerLink]="['/premium']">here</a> to learn more.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="premium" (afterExpand)="onExpand('premium-brands')" [expanded]="fragment() == 'premium-brands'">
        <mat-expansion-panel-header>
          <h3 id="premium-brands">What brands are on cloudigo Premium?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            You can see a full list of the brands on cloudigo <a routerLink="/premium/catalogue">here</a>
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="premium" (afterExpand)="onExpand('premium-cost')" [expanded]="fragment() == 'premium-cost'">
        <mat-expansion-panel-header>
          <h3 id="premium-cost">How much does it cost to become a Premium member?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            You can pay every 12 months. For current pricing and further information, click <a [routerLink]="['/premium']">here</a> 
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="premium" (afterExpand)="onExpand('premium-buy')" [expanded]="fragment() == 'premium-buy'">
        <mat-expansion-panel-header>
          <h3 id="premium-buy">How do I buy a Premium membership?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            In order to become a cloudigo Premium users, you must:
          </p>
          <ol>
            <li>
              Download the app on <a [href]="ios">iOS</a> or <a [href]="android">Android</a> and create an account
            </li>
            <li>
              Click on the Premium icon (the <span class="font-bold">crown</span>) in the bottom menu
            </li>
            <li>
              Enter your <span class="font-bold">payments details</span>
            </li>
            <li>
              Follow respective <span class="font-bold">3D secure</span> instructions from your bank and start saving! (You may need to authenticate your purchase by entering a pin code sent via SMS or push notification.)
            </li>
          </ol>
          <br/><br/>
          <p>
            If you have any discount codes to purchase cloudigo Premium at a reduced rate, please <a routerLink="/how-to-coupon">click here</a> to follow instructinos.

          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="premium" (afterExpand)="onExpand('premium-validity')" [expanded]="fragment() == 'premium-validity'">
        <mat-expansion-panel-header>
          <h3 id="premium-validity">How long is a cloudigo Premium membership valid for?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
                If you pay <span class="font-bold">per year</span>: The membership is <span class="font-bold">valid for a year from purchase date</span> and is automatically renewed each year unless you cancel in accordance with our Terms & Conditions.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="premium" (afterExpand)="onExpand('creditcard')" [expanded]="fragment() == 'creditcard'">
        <mat-expansion-panel-header>
          <h3 id="creditcard">Is it safe to enter my credit card details?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            It is safe for you to enter your credit card details inside our website. We take this very seriously and use a verified payment gateway.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="premium" (afterExpand)="onExpand('cloudigo-save')" [expanded]="fragment() == 'cloudigo-save'">
        <mat-expansion-panel-header>
          <h3 id="cloudigo-save">How much do I save with cloudigo Premium?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Do you want to know how much money you can save with cloudigo Premium? Use our <a routerLink="/premium/yearly/calculator">free savings calculator</a> to find out. 
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="premium" (afterExpand)="onExpand('premium-website')" [expanded]="fragment() == 'premium-website'">
        <mat-expansion-panel-header>
          <h3 id="premium-website">Is cloudigo Premium accessible through the cloudigo website?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            You can subscribe to cloudigo Premium on the <a [routerLink]="['/premium']">cloudigo website</a>, however, you may only redeem Premium offers by using the <a routerLink="/get-the-app">cloudigo mobile application</a>.
          </p>
        </ng-template>
      </mat-expansion-panel>

    </div>
    <!-- !RESTAURANTS/SHOPS/OFFERS SECTION -->
    <div>
      <h2 paint="primary" extrabold>Restaurants, Shops & Offers</h2>

      <mat-expansion-panel (afterExpand)="onExpand('offer-information')" [expanded]="fragment() == 'offer-information'">
        <mat-expansion-panel-header>
          <h3 id="offer-information">How do I find more information about an offer, restaurant or shop?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            You can easily learn more about the offer by clicking on an offer card. A detailed description of the offer and relevant terms and conditions will appear. You can also learn more about the restaurant or shop by clicking on the logo.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('offer-use')" [expanded]="fragment() == 'offer-use'">
        <mat-expansion-panel-header>
          <h3 id="offer-use">How do I use the offers on the app?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <ol>
              <li>
                Simply search or click on the offer you want to use
              </li>
              <li>
                Click on ‘Get Code’
              </li>
              <li>
                A camera will appear for you to scan the QR code provided by the shop or restaurant. If your camera doesn’t work, simply click on ‘Prefer to use a PIN code instead? Click here’ and the brand representative will provide you with a 4-digit pin code.
              </li>
              <li>
                Once validated, show the final code on the black screen to the cashier and enjoy your savings
              </li>
            </ol>
            <br/><br/>
          <p>
            If you have any discount codes to purchase cloudigo Premium at a reduced rate, please <a routerLink="/how-to-coupon">click here</a> to follow instructinos.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('offer-use-time')" [expanded]="fragment() == 'offer-use-time'">
        <mat-expansion-panel-header>
          <h3 id="offer-use-time">When should I tell the restaurant or shop that I want to use cloudigo?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            For most retail shops, it’s important that when you take your items to the cash register, you inform the cashier that you have a cloudigo discount. Make sure you have the code ready on the cloudigo app.
            <br/><br/>
            As for restaurant destinations, some require mentioning cloudigo upon booking, whilst others require mentioning cloudigo upon arrival at the restaurant. This will be stipulated in the terms & conditions of the offer. However, always mention cloudigo when asking the restaurant for the bill, so the discount can be applied immediately. 
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('offer-denial')" [expanded]="fragment() == 'offer-denial'">
        <mat-expansion-panel-header>
          <h3 id="offer-denial">The restaurant or shop won’t accept my cloudigo discount.</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            In the event that a restaurant or shop does not accept your offer code for some reason, make sure to read the terms and conditions on the offer card to clarify the validity of the offer. If you still experience issues with the shop or restaurant, please contact us directly on <a target="_top" rel="noreferrer" href="https://facebook.com/cloudigo">Facebook</a> by sending us a private message, or send an email to <a href="mailto:support@cloudigo.app">support&#64;cloudigo.app</a> and we will look into it ourselves. We may require you to provide proof of purchase (such as a valid receipt) in order to verify the claim and take appropriate action.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('offer-booking')" [expanded]="fragment() == 'offer-booking'">
        <mat-expansion-panel-header>
          <h3 id="offer-booking">Why do some restaurants or food outlets ask for booking in advance?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Some restaurants indicate in the offer terms and conditions that they require members to book in advance. This is because if the discount has not been mentioned and the bill is produced, the restaurant manager or waiter would then have to reproduce the bill; which can be time-consuming. If the restaurant is already aware that you are a cloudigo member, they can calculate the bill and factor in the discount.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (afterExpand)="onExpand('offer-online')" [expanded]="fragment() == 'offer-online'">
        <mat-expansion-panel-header>
          <h3 id="offer-online">How do I redeem an online offer?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <ol>
            <li>
              <span class="font-bold">Click</span> on the online offer
            </li>
            <li>
              Press on <span class="font-bold">‘Shop Now’</span>
            </li>
            <li>
              A code will display on a <span class="font-bold">pop-up</span> and the <span class="font-bold">website</span> of the respective online shop will open in a separate browser
            </li>
            <li>
              Add the items you wish to purchase in your <span class="font-bold">cart</span>
            </li>
            <li>
              Enter the <span class="font-bold">code</span> you save on the pop-up of the cloudigo app in the promo code field on the website you're buying from
            </li>
          </ol>
        </ng-template>
      </mat-expansion-panel>

    </div>
    <!-- !BILLING SECTION -->
    <div>
      <h2 paint="warn" extrabold>Billing</h2>

      <mat-expansion-panel class="premium" (afterExpand)="onExpand('cloudigo-payment')" [expanded]="fragment() == 'cloudigo-payment'">
        <mat-expansion-panel-header>
          <h3 id="cloudigo-payment">What payment methods can I use to buy cloudigo Premium?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            We accept valid Mastercard and VISA payment methods.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="premium" (afterExpand)="onExpand('payment-failed')" [expanded]="fragment() == 'payment-failed'">
        <mat-expansion-panel-header>
          <h3 id="payment-failed">My payment has failed, what should I do?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            There are a number of reasons why this can happen.
            <br/><br/>
            The most common reasons are usually:
          </p>
          <ul>
              <li>
                The card details are not inputted correctly
              </li>
              <li>
                The card may be expired
              </li>
              <li>
                You have insufficient funds
              </li>
            </ul>
          <br/>
          <p>
            Please double check your card details and try again. If you still don’t manage please contact us on <a target="_top" rel="noreferrer" href="https://facebook.com/cloudigo">Facebook</a> or send an email to <a href="mailto:support@cloudigo.app">support&#64;cloudigo.app</a>.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="premium" (afterExpand)="onExpand('cloudigo-billing')" [expanded]="fragment() == 'cloudigo-billing'">
        <mat-expansion-panel-header>
          <h3 id="cloudigo-billing">How do I change my billing details or add new card details?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            In order to change your billing details, simply login to your account from your application, visit your account profile and click on <a routerLink="/profile/billing">Billing Details</a>. To add a new card, click on ‘Add another payment method’.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="premium" (afterExpand)="onExpand('coupon')" [expanded]="fragment() == 'coupon'">
        <mat-expansion-panel-header>
          <h3 id="coupon">How do I use a coupon or coupon code?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <ol>
            <li>
              Upon checkout, insert your given coupon code in the ‘Got a Discount Code?’ box to apply the discount
            </li>
            <li>
              After clicking on Next, insert your payment details
            </li>
            <li>
              Complete your transaction
            </li>
          </ol>
          <br/>
          <p>
            For more instructions, <a routerLink="/how-to-discount-code">click here</a>.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="premium" (afterExpand)="onExpand('renewal')" [expanded]="fragment() == 'renewal'">
        <mat-expansion-panel-header>
          <h3 id="renewal">When will I be charged for Premium again?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Your membership will be renewed <span class="font-bold">every year</span>. Therefore your card will be charged each year as per our Terms and Conditions. 
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="premium" (afterExpand)="onExpand('premium-cancel')" [expanded]="fragment() == 'premium-cancel'">
        <mat-expansion-panel-header>
          <h3 id="premium-cancel">How can I cancel my cloudigo Premium membership?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            In order to stop your cloudigo Premium subscription from automatically renewing, simply:
          </p>
            <ol>
              <li>
                Login to the <span class="font-bold">cloudigo</span> application
              </li>
              <li>
                Visit your <span class="font-bold">account</span> profile and scroll down
              </li>
              <li>
                Click on <span class="font-bold">Subscription</span> and click on ‘Change Plan’
              </li>
            </ol>
            <p>
            <br/><br/>
            You will then be able to cancel your Premium Subscription and downgrade to the cloudigo Basic Plan. This means that your cloudigo Premium Plan won’t be renewed.
            <br/><br/>
            Nevertheless, you will still have access to your cloudigo Premium Plan until the indicated expiry date. Upon the mentioned expiry date, your account will be downgraded to the cloudigo Basic Plan. This is in accordance with our <a routerLink="/terms-and-conditions#cancellation">Cancellation Policy</a> found in our Terms and Conditions.
          </p>
        </ng-template>
      </mat-expansion-panel>

    </div>
    <!-- !TRAVELLER SECTION -->
    <div>
      <h2 paint="accent" extrabold>Traveller</h2>
      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('traveller')" [expanded]="fragment() == 'traveller'">
        <mat-expansion-panel-header>
          <h3 id="traveller">What is cloudigo Traveller?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            cloudigo Traveller Plan is a 30-day discount membership accessible via a 
            mobile application and/or website for tourists visiting the Maltese islands. 
            The membership enables incoming travellers to save money at restaurants, 
            retail shops, experiences and attractions whilst visiting Malta. It contains 
            around 200+ discounts on Dining, Shopping and Experiences in Malta & Gozo.
          </p>
          <br/>
          For more information, <a target="_top" rel="noreferrer" href="https://www.cloudigo.travel">click here</a>.
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('traveller-purchase')" [expanded]="fragment() == 'traveller-purchase'">
        <mat-expansion-panel-header>
          <h3 id="traveller-purchase">How do I purchase the cloudigo Traveller Plan?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            All you need to do is:
          </p>
          <ol>
            <li>
              Visit <a target="_top" rel="noreferrer" href="https://www.cloudigo.travel">cloudigo.travel</a>
            </li>
            <li>
              Click on <span class="font-bold">‘Buy cloudigo Traveller Plan’</span>
            </li>
            <li>
              Enter your <span class="font-bold">credit card details</span>
            </li>
            <li>
              <span class="font-bold">Sign up</span> to cloudigo to create your login credentials 
              and <span class="font-bold">view all your offers</span> before or during your trip
            </li>
            <li>
              Once in Malta, you will need to <span class="font-bold">download the cloudigo 
              app</span> on your smartphone from the App Store or Google 
              Play Store to access all your offers on the go.
            </li>
          </ol>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('traveller-cost')" [expanded]="fragment() == 'traveller-cost'">
        <mat-expansion-panel-header>
          <h3 id="traveller-cost">How much does it cost to purchase the cloudigo Traveller Plan?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            The cloudigo Traveller Plan is valid for 30 days and costs €19.99 (including applicable taxes).
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('traveller-purchase-date')" [expanded]="fragment() == 'traveller-purchase-date'">
        <mat-expansion-panel-header>
          <h3 id="traveller-purchase-date">When should I purchase the cloudigo Traveller Plan?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            We recommend purchasing the cloudigo Traveller Plan 1-3 months 
            before your trip so that you can book any excursions at a discounted 
            price from before. All excursions are subject to availability.
          </p>
          <p>
            However, one may also opt to purchase the cloudigo Traveller Plan just 
            before the arrival date or whilst in Malta.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('traveller-intro')" [expanded]="fragment() == 'traveller-intro'">
        <mat-expansion-panel-header>
          <h3 id="traveller-intro">What happens when I purchase the cloudigo Traveller Plan?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Once you purchase the cloudigo Traveller Plan on our website 
            <a target="_top" rel="noreferrer" href="https://www.cloudigo.travel">cloudigo.travel</a>, you will be asked to create an account on cloudigo. 
            In this account you will be able to see all the offers which you’ll be  
            eligible for whilst you’re here in Malta. You can book any excursions 
            from our platform at a discounted price before your trip.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('arrival')" [expanded]="fragment() == 'arrival'">
        <mat-expansion-panel-header>
          <h3 id="arrival">What do I do when I arrive in Malta?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            We recommend downloading the cloudigo app when you’re here in 
            Malta and logging in with your credentials. In order to use in-store offers 
            at restaurants, shops etc, you will need to use the cloudigo app.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('traveller-expiration')" [expanded]="fragment() == 'traveller-expiration'">
        <mat-expansion-panel-header>
          <h3 id="traveller-expiration">How do I check when my membership expires?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            You can check the expiry of your membership by visiting your profile and
             clicking on ‘Subscription’. The cloudigo Traveller Plan is valid for 30 days 
             since the start date you chose when purchasing this plan.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('payment-details')" [expanded]="fragment() == 'payment-details'">
        <mat-expansion-panel-header>
          <h3 id="payment-details">Is it safe to enter my credit card details?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            It is very safe for you to enter your credit card details. 
            We take this very seriously and we use a trusted payment gateway.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('traveller-save')" [expanded]="fragment() == 'traveller-save'">
        <mat-expansion-panel-header>
          <h3 id="traveller-save">How much money can I save with the cloudigo Traveller Plan 
            during my holiday here in Malta?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            We calculate that you can save over €200 whilst in Malta when booking 
            attractions through our platform, as well as, dining and shopping using 
            our application. 
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('traveller-contact')" [expanded]="fragment() == 'traveller-contact'">
        <mat-expansion-panel-header>
          <h3 id="traveller-contact">How do I contact cloudigo?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <ul>
            <li>
              Email: <a href="mailto:travel@cloudigo.app">travel&#64;cloudigo.app</a>
            </li>
            <li>
              Facebook: <a target="_top" rel="noreferrer" href="https://facebook.com/cloudigo">facebook.com/cloudigo</a>
            </li>
          </ul>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('yellow-offers')" [expanded]="fragment() == 'yellow-offers'">
        <mat-expansion-panel-header>
          <h3 id="yellow-offers">What do the yellow offers mean?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            The offer cards marked in <span paint="accent" class="font-bold">yellow</span>
             refer to cloudigo Traveller discounts that may be used by the cloudigo 
             Traveller users only. These include discounts on Dining, Shopping and 
             Experiences up to 50% OFF.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('grey-offers')" [expanded]="fragment() == 'grey-offers'">
        <mat-expansion-panel-header>
          <h3 id="grey-offers">What do the grey offers mean?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            If the offer card on the app is grey and the button shows 
            ‘<span class="font-bold">NOT VALID TODAY</span>’, or if on the offer page at the bottom 
            there is a grey button showing ‘<span class="font-bold">NOT VALID TODAY</span>’, this means 
            that the offer is not valid and cannot be redeemed on that particular 
            day. If the offer card shows a specific time in which the offer is valid, 
            this means that the offer cannot be redeemed outside of these hours.
            </p>
            <p>
              If the offer card used on the app is grey and the button shows ‘<span class="font-bold">USED</span>’, 
              or if on the offer page at the bottom there is a grey button showing 
              ‘<span class="font-bold">USED</span>’, this means that the number of limited redemptions have been 
              used up and the offer cannot be used again until the period of time 
              required for the offer to be reset has passed.
            </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('fav-offers')" [expanded]="fragment() == 'fav-offers'">
        <mat-expansion-panel-header>
          <h3 id="fav-offers">Can I save my favourite offers?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            You can save any offers you wish to use by clicking on the heart icon 
            on the offer. You can then find these saved offers in your wallet, 
            by clicking on the Wallet icon on the top right of the app homepage.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('membership-save')" [expanded]="fragment() == 'membership-save'">
        <mat-expansion-panel-header>
          <h3 id="membership-save">Can I see how much money I am saving with this membership?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Of course! You will be able to see the estimated savings on the top of 
            the homepage of the app, as well as, on the profile.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('app-offer-use')" [expanded]="fragment() == 'app-offer-use'">
        <mat-expansion-panel-header>
          <h3 id="app-offer-use">How do I use the offers on the app?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>You will notice that there are two types of offers:</p>
            <ol>
              <li>
                <span class="font-bold">In-store</span> offers from restaurants, shops and attractions which require you to be in Malta to use them. In that case:
                <ul>
                  <li>Simply search or click on the offer you want to use</li>
                  <li>Click on ‘Get Code’ </li>
                  <li>A camera will appear for you to scan the QR code provided by the shop or restaurant. If your camera doesn’t work, simply click on ‘Prefer to use a PIN code instead? Click here’ and the brand representative will provide you with a 4-digit pin code.</li>
                  <li>Once validated, show the final code on the black screen to the cashier and enjoy your savings</li>
                </ul>
              </li>
              <li>
                Online offers such as booking excursions, activities etc which you may need to book before you come to Malta due to availability. In that case:
                <ul>
                  <li><span class="font-bold">Click</span> on the online offer</li>
                  <li>Press on <span class="font-bold">‘Shop Now’</span> to see the excursion at the discounted price</li>
                  <li>Proceed to <span class="font-bold">booking</span> and <span class="font-bold">payment</span></li>
                </ul>
              </li>
            </ol>
          <p>
            If you have any discount codes to purchase cloudigo Premium at a reduced rate, please <a routerLink="/how-to-coupon">click here</a> to follow instructinos.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('excursion-query')" [expanded]="fragment() == 'excursion-query'">
        <mat-expansion-panel-header>
          <h3 id="excursion-query">I have a query about one of the excursions I booked.</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            After booking an excursion via cloudigo, you will receive a booking 
            confirmation email from the excursion travel agent. Any queries related 
            to such bookings must be made directly to the respective agent and 
            contact details will be included in this email.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('traveller-payment')" [expanded]="fragment() == 'traveller-payment'">
        <mat-expansion-panel-header>
          <h3 id="traveller-payment">What payment methods can I use to buy cloudigo Traveller Plan?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            We accept valid Mastercard and VISA payment methods.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('trip-edit')" [expanded]="fragment() == 'trip-edit'">
        <mat-expansion-panel-header>
          <h3 id="trip-edit">What happens if I have to change the dates of my trip?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Should this happen, please contact us on travel&#64;cloudigo.app so that we can change 
            your start date of the application. Please note you will have a year to activate the membership.
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('trip-cancel')" [expanded]="fragment() == 'trip-cancel'">
        <mat-expansion-panel-header>
          <h3 id="trip-cancel">What happens if I cancel my trip?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            The cloudigo Traveller Plan is non-refundable. In the event of any cancellation, any concerns 
            related to excursions purchased via cloudigo must be made directly to the excursion agent.
          </p>
          <p>
            Contact details of such excursion agent can be found in the booking confirmation email 
            you would have received. 
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel class="traveller" (afterExpand)="onExpand('excursion-amend')" [expanded]="fragment() == 'excursion-amend'">
        <mat-expansion-panel-header>
          <h3 id="excursion-amend">What happens if I need to amend the excursion date?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Should this happen, kindly contact the excursion provider whose contact details are to 
            be found on the booking confirmation email. 
          </p>
        </ng-template>
      </mat-expansion-panel>

    </div>
  </mat-accordion>
</div>